import { ICommand, IDefineCommand } from 'core-ts-types';
import { FeedbackSuggestedPlanModel } from './../models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from './../servants/plan_feedback_servant';

angular
  .module('capability-ng-academic-planner')
  .service(
    'dropAndCreateSuggestedPlanCommand',
    (
      createEmptySuggestedPlanCommand: ICommand,
      deleteSuggestedPlanCommand: ICommand,
      defineCommand: IDefineCommand,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
    ) =>
      defineCommand('dropAndCreateSuggestedPlanCommand', (deferred) => {
        if (PlanFeedbackServant.isPlanReadOnlyMode(ngFeedbackSuggestedPlanModel.read())) {
          return createEmptySuggestedPlanCommand();
        }
        return deleteSuggestedPlanCommand().finally(() =>
          createEmptySuggestedPlanCommand().finally(() => deferred.resolve())
        );
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/drop_and_create_suggested_plan_command.ts